var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-1 mb-1 text-right"},[_c('a',{class:_vm.modoDark_var? 'btn DarkActive' : 'btn btn-vino-o',staticStyle:{"border-radius":"22px"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Atrás ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }